















import Vue from 'vue'
import radarList from './json/radarList.json'

export default Vue.extend({
  props: ['barId'],

  watch: {
    barId(val) {
      console.log(val)
      this.getDataList(val)

    }
  },
  data() {
    return {
      dataList: radarList.slice(0, 4),
      check: true,
      checkText: '衡阳'
    }
  },
  mounted() {
    this.getDataList(this.barId)
  },
  methods: {
    getDataList(val: string) {
      if (val === 'radar') {
        this.dataList = radarList.slice(0, 4)
      } else if (val === 'radar_mosaic') {
        this.dataList = radarList.slice(4, radarList.length)
      }
      const item = this.dataList[0]
      this.checked(item)
    },
    checked(item: any) {
      this.check = true
      this.checkText = item.text
      this.$emit('checkRadar', item.id)

    },
  },
})
